exports.formatLink = (slug, pageType = null) => {
	if(slug === 'ALL'){
		return pathConstantForPageType('ALL', pageType)
	}

	let link = '/'

	let path = pathForPageType(pageType)
	if(path){
		link = addSlugToLink(path, link)
	}

	
	const slugParts = slug.split('#')
	link = addSlugToLink(slugParts[0], link)
	if(slugParts.length > 1){
		link += '#' + slugParts[1]
	}

	return link
}

const addSlugToLink = (slug, link) => {
	if(slug.charAt(0) === '/'){
		slug = slug.slice(1)
	}

	link += slug

	if(link.slice(-1) !== '/'){
		link += '/'
	}

	return link
}

const pathForPageType = (pageType) => {
	switch(pageType){
		default:
			return null
	}
}

const pathConstantForPageType = (constant, pageType) => {
	switch(pageType){
		case 'category':
			return '/stories/archive/all/'
	}
}

exports.linkSameMinusHash = (a, b) => {
	return a.split('#')[0] === b.split('#')[0]
}